import React from "react";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import MapMarker from "./MapMarker";
import { ICoords, IDistributors } from "../models";

const containerStyle = {
  width: "100%",
  height: "630px",
};

interface CoordsProps {
  center: ICoords;
  distributors: IDistributors[];
  zoomLevel: number;
}

function Map({ center, distributors, zoomLevel }: CoordsProps) {
  return (
    <LoadScript googleMapsApiKey="AIzaSyBmNjRVRwC-lO3_U1lPKOxqoaimAgoIKBI">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoomLevel}
      >
        {distributors?.map((item: any, index: number) => {
          return <MapMarker key={index} distributor={item} />;
        })}
      </GoogleMap>
    </LoadScript>
  );
}

export default Map;
